export default "__VITE_ASSET__BNPlAqO5__"